/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccessRequestPostRequest
 */
export interface AccessRequestPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestPostRequest
     */
    app_external_connection_id: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestPostRequest
     */
    identifier_from_source: string;
    /**
     * Person ID
     * @type {string}
     * @memberof AccessRequestPostRequest
     */
    person_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestPostRequest
     */
    action?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestPostRequest
     */
    target?: string;
    /**
     * 
     * @type {Date}
     * @memberof AccessRequestPostRequest
     */
    valid_until?: Date;
}

/**
 * Check if a given object implements the AccessRequestPostRequest interface.
 */
export function instanceOfAccessRequestPostRequest(value: object): value is AccessRequestPostRequest {
    if (!('app_external_connection_id' in value) || value['app_external_connection_id'] === undefined) return false;
    if (!('identifier_from_source' in value) || value['identifier_from_source'] === undefined) return false;
    return true;
}

export function AccessRequestPostRequestFromJSON(json: any): AccessRequestPostRequest {
    return AccessRequestPostRequestFromJSONTyped(json, false);
}

export function AccessRequestPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestPostRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'app_external_connection_id': json['app_external_connection_id'],
        'identifier_from_source': json['identifier_from_source'],
        'person_id': json['person_id'] == null ? undefined : json['person_id'],
        'action': json['action'] == null ? undefined : json['action'],
        'target': json['target'] == null ? undefined : json['target'],
        'valid_until': json['valid_until'] == null ? undefined : (new Date(json['valid_until'])),
    };
}

export function AccessRequestPostRequestToJSON(json: any): AccessRequestPostRequest {
    return AccessRequestPostRequestToJSONTyped(json, false);
}

export function AccessRequestPostRequestToJSONTyped(value?: AccessRequestPostRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'app_external_connection_id': value['app_external_connection_id'],
        'identifier_from_source': value['identifier_from_source'],
        'person_id': value['person_id'],
        'action': value['action'],
        'target': value['target'],
        'valid_until': value['valid_until'] == null ? value['valid_until'] : value['valid_until'].toISOString(),
    };
}

